import { Button, Modal, Table, Space } from 'antd';
import React from 'react';
import { PCodeUploadResult, ValidationError } from 'services/pcodes/types';
import styled from 'styled-components';

const ModalButtons = styled.div`
  margin-top: 24px;
`;

const SubTitle = styled.h4`
  margin-top: 8px;
`;

const StyledTable = styled(Table)`
  .ant-table-body {
    max-height: calc(100vh - 390px) !important;
  }
`;

export const validationErrorColumns = [
  {
    title: 'CSV RowNumber',
    dataIndex: 'rowNumber',
    width: 50
  },
  {
    title: 'Pcode',
    dataIndex: 'pcode',
    width: 150
  },
  {
    title: 'Error description',
    dataIndex: 'description',
    width: 350
  }
];

export interface IPCodesDeltaValidationErrorsModal {
  uploadResult: PCodeUploadResult;
}

const PCodesDeltaValidationErrorsModal = ({
  uploadResult
}: IPCodesDeltaValidationErrorsModal) => {
  return (
    <>
      <SubTitle>
        There seem to be one or more validation issues with the Pcodes you are
        trying to upload. Please make appropriate adjustments and re-upload
        afterwards.
      </SubTitle>
      <StyledTable
        // @ts-ignore
        columns={validationErrorColumns}
        dataSource={uploadResult.errors}
        size="small"
        pagination={false}
        scroll={{ y: 600 }}
      />
      <ModalButtons>
        <Space>
          <Button
            type="primary"
            onClick={() => {
              Modal.destroyAll();
            }}
          >
            OK
          </Button>
        </Space>
      </ModalButtons>
    </>
  );
};

export default PCodesDeltaValidationErrorsModal;
